<div id="gemsTopButton">
  <a (click)="goTo()" class="misc-btn-top top-button-hidden">Back to top</a>
</div>
